import { type ComponentProps, memo } from 'react';
import { type UseFormRegisterReturn } from 'react-hook-form';

import { Field, FieldLabel, FieldText } from '@air/primitive-field';
import { Input } from '@air/primitive-input';

export type DemoFormTextFieldProps = {
  errorMessage: string | undefined;
  fieldId: string;
  label: string;
  registerProps: UseFormRegisterReturn;
} & Pick<ComponentProps<typeof Input>, 'autoComplete' | 'placeholder' | 'required' | 'type'>;

export const DemoFormTextField = memo(
  ({
    autoComplete,
    errorMessage,
    fieldId,
    label,
    placeholder,
    registerProps,
    required,
    type,
  }: DemoFormTextFieldProps) => {
    const errorId = `${fieldId}-error`;

    return (
      <Field className="w-full">
        <FieldLabel className="sr-only" htmlFor={fieldId}>
          {label}
        </FieldLabel>
        <Input
          aria-describedby={errorMessage ? errorId : undefined}
          aria-invalid={Boolean(errorMessage)}
          autoComplete={autoComplete}
          data-1p-ignore
          hasError={Boolean(errorMessage)}
          id={fieldId}
          placeholder={placeholder}
          required={required}
          size="large"
          type={type}
          {...registerProps}
        />
        {errorMessage ? (
          <FieldText color="red" id={errorId}>
            {errorMessage}
          </FieldText>
        ) : null}
      </Field>
    );
  },
);

DemoFormTextField.displayName = 'DemoFormTextField';
